'use client'

import React from 'react'
import AnimatedSection from '@/components/AnimatedSection'
import Typography from '@/components/Typography'
import styles from './styles.module.css'

const forWhoms = [
	{
		title: 'E-commerce и ритейл',
		description: 'Интернет-магазины и маркетплейсы, где каждая минута простоя — это потеря заказов.',
		icon: '/services/shopping_cart.svg',
		pains: [
			'Сайт «падает» в распродажи',
			'Медленно работает корзина',
			'Теряются интеграции с 1С.'
		],
		solutions: [
			'Мониторинг бизнес-метрик',
			'Оптимизация сайта для SEO',
			'Подготовка к высоким нагрузкам'
		]
	},
	{
		title: 'Финтех и B2B-сервисы',
		description: 'Проекты с Личными кабинетами, платежными шлюзами и высокими требованиями к защите данных.',
		icon: '/services/for-whom-fintech.svg',
		pains: [
			'Риск утечки данных',
			'Ошибки в транзакциях',
			'Сложная логика архитектуры'
		],
		solutions: [
			'Глубокий рефакторинг кода',
			'Защита от DDoS',
			'Поддержка сложных интеграций'
		]
	},
	{
		title: 'Промышленность',
		description: 'Крупный бизнес, которому нужно оцифровать процессы: от каталогов продукции до порталов для дилеров.',
		icon: '/services/factory.svg',
		pains: [
			'Сайт «оторван» от склада',
			'Неактуальные цены',
			'Сложно обновлять контент'
		],
		solutions: [
			'Бесшовная интеграция сайта',
			'Авто обновление цен и остаткой',
			'Настройка админ.панели'
		]
	}
]


const ForWhom: React.FC = () => {
	return (
		<section className={styles.section}>
	<AnimatedSection animation="slideUp">
		<div className={styles.heading}>
			<Typography variant="h4" color="accent" className={styles.subtitle}>
				Для кого
			</Typography>
			<Typography variant="h2" className={styles.title}>
				Кому мы будем полезны
			</Typography>
		</div>
	</AnimatedSection>

	<AnimatedSection animation="slideUp">
		<div className={styles.grid}>
			{forWhoms.map((item, idx) => (
				<div key={idx} className={styles.card}>
					<div className={styles.iconContainer}>
						<img src={item.icon} alt={item.title} className={styles.icon} />
					</div>
					<Typography variant="h4" className={styles.cardTitle}>
						{item.title}
					</Typography>
					<Typography variant="p1" color="description" className={styles.cardDescription}>
						{item.description}
					</Typography>
					<div className={styles.lists}>
						<div className={styles.list}>
							<Typography variant="p1" className={styles.listTitle}>
								Боли
							</Typography>
							<div className={styles.listContent}>
								<ul className={`${styles.listItems} ${styles.listPains}`}>
									{item.pains.map((pain, i) => (
										<li key={i} className={styles.listItem}>{pain}</li>
									))}
								</ul>
							</div>
						</div>
						<div className={styles.list}>
							<Typography variant="p1" className={styles.listTitle}>
								Решение
							</Typography>
							<div className={styles.listContent}>
								<ul className={`${styles.listItems} ${styles.listSolutions}`}>
									{item.solutions.map((solution, i) => (
										<li key={i} className={styles.listItem}>{solution}</li>
									))}
								</ul>

							</div>
						</div>
					</div>
				</div>
			))}
		</div>
	</AnimatedSection>
</section>
	)
}

ForWhom.displayName = 'ForWhom'

export default ForWhom

